import React from 'react';
import { useTranslation } from 'react-i18next';

import { getFormattedPrice } from 'utility/Format/Price';

export interface StrikeThroughPriceProps {
    difference: number;
    type?: string;
    showVariationHint?: boolean;
    hasCheapestTooltip?: boolean;
}

const StrikeThroughPrice = ({
    type,
    difference,
    showVariationHint = true,
    hasCheapestTooltip = false,
}: StrikeThroughPriceProps) => {
    const { t } = useTranslation();
    let strikePriceWording = '';
    const formattedDifference = getFormattedPrice(difference);
    const priceVariationTransKey = hasCheapestTooltip
        ? 'TRANS-price-variation-hint-cheapest'
        : 'TRANS-price-variation-hint';

    switch (type) {
        case 'earlyBird':
            strikePriceWording = `${t('TRANS-earlybird-deal')}: `;
            break;
        case 'lastMinute':
            strikePriceWording = `${t('TRANS-lastminute-deal')}: `;
            break;
    }

    return (
        <>
            <strong>
                {t('TRANS-strike-price-info-headline', {
                    strikePriceWording,
                    formattedDifference,
                })}
            </strong>
            <p>{t('TRANS-strike-price-info-1', { formattedDifference })}</p>
            <p>{t('TRANS-strike-price-info-2')}</p>
            {showVariationHint && (
                <div
                    dangerouslySetInnerHTML={{
                        __html: t(priceVariationTransKey),
                    }}
                />
            )}
        </>
    );
};

export default StrikeThroughPrice;
